/** @format */
import { ButtonIconProps } from '@mpb-com/feather/components/atoms/icon';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum NavigationButtonDirection {
    UP = 'up',
    DOWN = 'down',
    LEFT = 'left',
    RIGHT = 'right',
}

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type NavigationButtonProps = ButtonIconProps & {
    /**
     * @default UP
     */
    direction: NavigationButtonDirection;
};

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type StyledNavigationButtonProps = Pick<
    NavigationButtonProps,
    'direction'
>;
